export default __webpack_public_path__ + "static/media/petal-flower-lg.55e4f803.gif";